import {includes} from 'lodash';
import {prevSelectedKeys} from '../constants/filters.data';
import {PrevSelectedData} from '../store/prevSelectedStore';

export const isPrevSelectedKey = (key: string): key is keyof PrevSelectedData => {
  return includes(prevSelectedKeys, key);
};
